import { render, staticRenderFns } from "./templates.view.vue?vue&type=template&id=b0c34280&scoped=true&"
import script from "./templates.view.ts?vue&type=script&lang=ts&"
export * from "./templates.view.ts?vue&type=script&lang=ts&"
import style0 from "./templates.view.scss?vue&type=style&index=0&id=b0c34280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c34280",
  null
  
)

export default component.exports